import React from 'react';
import axios from 'axios';
import CustomTabForm from '../CustomTabForm';
import { withAuth } from '@cdk-prod/fortellis-auth-context';

const API_REQUEST_BODY = {
  notificationType: 'Subscription',
  solutionInfo: {
    id: 'sample-id-for-testing',
    name: 'Sample Solution Name'
  },
  planInfo: {
    name: 'Test Plan',
    description: 'Test Plan Description'
  },
  subscriptionInfo: {
    id: 'sample-id-for-testing',
    subscribedBy: 'john.doe@test.com'
  }
};

class FormAPIRequest extends React.Component {
  constructor(props) {
    super(props);

    this.configObj = {
      tabs: [
        {
          id: 'request',
          label: 'Request',
          contents: [
            {
              id: 'request',
              fields: [
                {
                  id: 'apiRequestBody',
                  name: 'apiRequestBody',
                  label: 'API Request',
                  type: 'json_text_area',
                  style: ['formtextfield', 'form-text-area'],
                  gridStyle: 'layoutCellList',
                  toolTipText: 'The body sent with the API POST request',
                  src: API_REQUEST_BODY
                },
                {
                  name: 'testButton',
                  label: 'Test',
                  type: 'button',
                  gridStyle: 'layoutCellList',
                  onBtnClick: async () => {
                    await this.testAPICall();
                  }
                }
              ]
            }
          ]
        },
        {
          id: 'response',
          label: 'Response',
          contents: [
            {
              id: 'response',
              fields: [
                {
                  id: 'apiResponse',
                  name: 'apiResponse',
                  label: 'API Response',
                  type: 'json_text_area',
                  style: ['formtextfield', 'form-text-area'],
                  gridStyle: 'layoutCellList',
                  toolTipText: 'The response sent by the API call',
                  src: {}
                }
              ]
            }
          ]
        }
      ],
      activeTabId: 'request'
    };

    this.state = {
      config: this.configObj
    };
  }

  static getDerivedStateFromProps(prevProps, prevState) {
    prevState.config.tabs[0].contents[0].fields[1].isDisabled =
      prevProps.formFieldValues.endpointUrl &&
      prevProps.formFieldValues.endpointUrl.trim().length
        ? false
        : true;
    return {
      config: prevState.config
    };
  }

  onTabChange(activeTabId) {
    this.setState({
      config: Object.assign({}, this.state.config, { activeTabId })
    });
  }

  testAPICall = async () => {
    const { endpointUrl } = this.props.formFieldValues;
    if (endpointUrl) {
      const {
        auth: { accessToken }
      } = this.props;
      const tokenValue = accessToken
        ? accessToken.startsWith('Bearer ')
          ? accessToken
          : `Bearer ${accessToken}`
        : null;
      const headers = {
        'Content-Type': 'application/json'
      };
      if (tokenValue) {
        headers.Authorization = tokenValue;
      }
      const requestBody = {
        operationName: 'NotifyUrlTest',
        query:
          'mutation NotifyUrlTest($command: NotifyUrlCmd) { notifyUrl(command: $command) { status } }',
        variables: {
          command: {
            endpointUrl,
            payload: JSON.stringify(API_REQUEST_BODY)
          }
        }
      };
      const graphQLEndpoint = process.env.REACT_APP_GRAPHQL_URI || '/graphql';

      try {
        const apiResponse = await axios.post(graphQLEndpoint, requestBody, {
          headers
        });
        const notifyStatus = apiResponse?.data?.data?.notifyUrl?.status;
        const graphQLErrors = apiResponse?.data?.errors;
        const isSuccessful = notifyStatus === 'SUCCESSFUL';

        this.configObj.tabs[1].contents[0].fields[0].src = {
          status: notifyStatus || 'FAILED',
          message: isSuccessful
            ? 'Test notification sent'
            : graphQLErrors && graphQLErrors.length
            ? graphQLErrors[0].message
            : 'Test notification failed',
          errors: graphQLErrors || [],
          response: apiResponse.data
        };
        this.configObj.activeTabId = 'response';
        this.setState({ config: this.configObj });
      } catch (err) {
        const graphQLError =
          err?.response?.data?.errors && err.response.data.errors.length
            ? err.response.data.errors[0].message
            : null;

        this.configObj.tabs[1].contents[0].fields[0].src = {
          status: 'FAILED',
          message: graphQLError || 'Test notification failed',
          errors: err?.response?.data?.errors || [],
          error: err?.message || err,
          response: err?.response?.data || null
        };
        this.configObj.activeTabId = 'response';
        this.setState({ config: this.configObj });
      }
    }
  };

  render() {
    return (
      <CustomTabForm
        {...this.props}
        formConfig={this.state.config}
        isSolutionReview={true}
        onTabChange={this.onTabChange.bind(this)}
      />
    );
  }
}

export { FormAPIRequest };
export default withAuth(FormAPIRequest);
